import { register } from "../helpers/stimulus"

import DisclosureItemController from "../controllers/disclosure_item_controller"
import FooterController from "../controllers/footer_controller"

const setupFooter = (): void => {
  register("disclosure-item", DisclosureItemController)
  register("footer", FooterController)
}

export { setupFooter }
